import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {COIService} from '../coi.service';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VoluntaryLoadManagementEventService extends COIService {
  protected apiUrl: string = environment.e2xApiUrl;
  public acknowledgeEvent(customerId: number, decision: 'accept' | 'deny', eventId: number) {

    return this.httpGet2(`${this.apiUrl}/emails/load-management-event-participation/${customerId}/${decision}/${eventId}`)
      .pipe(map((response) => {
        return {data: response};
      }));
  }
}
